module.exports = __webpack_public_path__ + "static/media/logo_text@2x.c429b530.png";